import { render, staticRenderFns } from "./EditMenuDialog.vue?vue&type=template&id=267a6133&scoped=true&"
import script from "./EditMenuDialog.vue?vue&type=script&lang=ts&"
export * from "./EditMenuDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267a6133",
  null
  
)

export default component.exports